import "./Card.css";

const Card = ({
  title,
  subtitle,
  children,
  actions,
  variant = "default",
  padding = "md",
  hoverable = true,
  className = "",
  onClick,
  id,
}) => {
  return (
    <div
      id={id}
      className={`ui-card ${variant} ${padding} ${hoverable ? "hoverable" : ""} ${className}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              // Keys on buttons/inputs inside the card belong to them.
              if (e.target !== e.currentTarget) return;
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
    >
      {(title || subtitle || actions) && (
        <div className="ui-card-header">
          <div>
            {title && <h3>{title}</h3>}
            {subtitle && <p>{subtitle}</p>}
          </div>

          {actions && <div>{actions}</div>}
        </div>
      )}

      <div className="ui-card-body">{children}</div>
    </div>
  );
};

export default Card;